// extracted by mini-css-extract-plugin
export default {"title":"modals_title__nr6dA","modal":"modals_modal__p68cU"};